// extracted by mini-css-extract-plugin
export default {"iconCopy":"IconCopy_iconCopy__sCi6J","icon":"IconCopy_icon__TLBTw"};